$(document).ready(function () {
    let $userWarnings = $('.ads-user-info');

    $('.btn-accept-disabled').on('click', function (e) {
        e.preventDefault();
        let $acceptBtn = $(this);
        let $agreementCheckbox = $('#agreement-checkbox');

        if (
            $agreementCheckbox.is(':checked')
            && $userWarnings.length === 0
            && !$acceptBtn.hasClass('acceptance-required')
        ) {
            window.location.href = $acceptBtn.attr('href');
        }
    })

    $('#agreement-checkbox').on('change', function () {
        let $acceptBtn = $('.btn.btn-accept');

        if ($userWarnings.length === 0) {
            $acceptBtn.toggleClass('btn-accept-disabled');
            $acceptBtn[0].toggleAttribute('disabled');
        }
    });
});